import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './Tabs.module.css'

interface Tab {
  id: string
  label: string
}

interface TabsProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (tabId: string) => void
  children: React.ReactNode
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, children }) => {
  const { t } = useTranslation()
  return (
    <div className="mx-3">
      {/* 标签页导航 */}
      <div className="w-full flex justify-center items-center">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => {
              onTabChange(tab.id)
            }}
            className={`inline-flex items-center justify-center h-10 flex-1 text-base font-medium transition-all duration-300 border-b-2 bg-transparent border-0 ${activeTab === tab.id ? styles.active : styles.normal}`}>
            {tab.label}
          </button>
        ))}
      </div>
      <div className="my-3 flex justify-between items-center text-sm text-[#282828]">
        <span>{t('home.functions')}</span>
        <span>{t('home.functionSwitch')}</span>
      </div>

      {/* 标签页内容容器 */}
      <div className="pb-15">{children}</div>
    </div>
  )
}

export default Tabs
